import React from "react";
import { Box, Typography, Button } from "@material-ui/core";
import { BLUE } from "../../constants/color";
import { Link } from "react-router-dom";

export default function ServerError() {
  return (
    <div class="error-layout">
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Typography
          variant="h1"
          style={{
            fontFamily: "HelveticaNeue-Bold",
            fontSize: 184
          }}
        >
          500
        </Typography>
        <Typography
          variant="p"
          style={{ fontFamily: "HelveticaNeue", fontSize: 34 }}
        >
          Internal Server Error
        </Typography>
        <Box mt={4}>
          <Button
            component={Link}
            to="/"
            style={{ color: BLUE }}
            color="primary"
            disableElevation
          >
            Go Home
          </Button>
        </Box>
      </Box>
    </div>
  );
}
